import React from 'react';
import './Mostcountries.css';
import countrie from '../../../imgs/countries1.webp';
import countri from '../../../imgs/countries2.webp';
import countr from '../../../imgs/countries3.webp';

const Mostcountries = () => {
    return (
        <div className="Rotaryinj-container">
            <div className='Ordinarys'>
                <h2 className="Rotaryinj-title">The most common pallets currently used in most countries are these 6 specifications:</h2>

                <div className="Rotaryinj-content">
                    <ul className="Rotaryinj-text">
                        <li>1067 mm × 1067 mm: North America, Europe, Asia.</li>
                        <li>1165 mm × 1165mm: Australia, New Zealand.</li>
                        <li>1100 mm × 1100 mm: Asian size (Japan, Korea, Singapore and other Southeast Asian countries).</li>
                        <li>1200 mm × 800 mm: European specifications (Germany, France, etc.).</li>
                        <li>1200 mm × 1000 mm: European(UK, Netherlands,   Finland) Canada, China and most other countries.</li>
                        <li>1219 mm × 1016 mm: US specification.</li>
                    </ul>
                    <p className="Rotaryinj-text">At present, there are two conventional heights of plastic pallets,
                        one is 140mm and the other is 150mm. For special industries,
                        the height of plastic pallets is also 110mm,160mm, 170mm, and 185mm.</p>
                    <p className="Rotaryinj-text">Plastic pallets with a height of 110 mm can only be used as a warehouse backing
                        plate, they cannot cooperate with manual and hydraulic forklifts,
                        and they cannot be used for turnover goods.
                        The other three heights can be used normally with forklifts.</p>
                </div>
                <div className="Mostcountr">
                    <img src={countrie} alt="72 Cavity PET Preforms Machine" className="Rotaryi-image" />
                    <img src={countri} alt="72 Cavity PET Preforms Machine" className="Rotaryi-image" />
                    <img src={countr} alt="72 Cavity PET Preforms Machine" className="Rotaryi-image" />

                </div>



            </div>

        </div>
    );
};

export default Mostcountries;
